import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import { Loading } from '../components/Loading';
import type { ProjectSummary } from '../types';

export default function Projects() {
  const [items, setItems] = useState<ProjectSummary[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .docsProjects()
      .then(setItems)
      .catch((e) => setErr(String(e)));
  }, []);

  if (err)
    return (
      <div className="view-wrap">
        <div className="err-detail">Ошибка: {err}</div>
      </div>
    );
  if (!items) return <Loading />;

  return (
    <div className="view-wrap">
      <h1>Проекты</h1>
      {items.length === 0 ? (
        <p className="lead">Витрина проектов пока пуста.</p>
      ) : (
        <div className="tiles">
          {items.map((p) => (
            <Link key={p.slug} to={`/projects/p/${p.slug}`} className="tile">
              <div className="tile-icon">{(p.title ?? p.slug).charAt(0).toUpperCase()}</div>
              <div className="tile-title">{p.title ?? p.slug}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
